import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';

import { influencerCampaignValues, influencerSubscriptionCampaignValues } from '../influencers.config';

import type { CampaignName } from 'src/common/enums/campaigns';
import {
  useInfluencerAdditionalConfigs,
  useInfluencerSubscriptionAdditionalConfigs,
} from './use-influencer-additional-configs';

const FOURTY_EIGHT_HOURS_IN_MS = 48 * 60 * 60 * 1000;

export const useInfluencerCampaign = (influencerCampaign?: CampaignName) => {
  const { campaign } = useActiveCampaign();
  const isInInCurrentInfluencerSession =
    !!influencerCampaign && (influencerCampaignValues as readonly string[]).includes(influencerCampaign);
  const additionalConfigs = useInfluencerAdditionalConfigs(influencerCampaign);
  const userFriendlyName = additionalConfigs?.userFriendlyName ?? '';

  const startTime = campaign?.startTime ?? 0;
  const endTime = startTime + FOURTY_EIGHT_HOURS_IN_MS;
  const isExtended = Date.now() > endTime;

  const hoursUntilEnd = (endTime - Date.now()) / (60 * 60 * 1000);
  const shouldIncludeDays = hoursUntilEnd > 24;
  const percentageOff = additionalConfigs?.percentageOff ?? 0;
  return {
    campaign,
    isInInCurrentInfluencerSession,
    isExtended,
    userFriendlyName,
    shouldIncludeDays,
    calculatedEndTime: endTime,
    percentageOff,
  };
};

export const useInfluencerSubscriptionCampaign = (influencerCampaign: CampaignName) => {
  const { campaign } = useActiveCampaign();
  const isInCurrentInfluencerSession =
    !!influencerCampaign && (influencerSubscriptionCampaignValues as readonly string[]).includes(influencerCampaign);
  const additionalConfigs = useInfluencerSubscriptionAdditionalConfigs(influencerCampaign);
  const userFriendlyName = additionalConfigs?.userFriendlyName ?? '';
  const percentageOff = additionalConfigs?.percentageOff ?? 0;

  return {
    campaign,
    isInCurrentInfluencerSession,
    userFriendlyName,
    percentageOff,
  };
};
